<div class="page">
  <pla-main-nav-chips></pla-main-nav-chips>
  <div class="content-container extended">
    <div class="px-0 px-md-1 py-0 me-0">
      <div style="background: #E5F1EF" class="py-4 px-4 px-md-5">
        <h1 class="d-block h1 fw-bold text-start mb-4">Privacy Policy</h1>
        <p class="fw-normal fs-md-16 fs-mb-14 mb-0">
          PlateX is committed to protecting your privacy. This page is required for compliance (e.g. Facebook App review). Content can be updated by the team.
        </p>
      </div>
      <div class="py-3 px-4 px-md-5 py-md-5 container-fluid rounded-3">
        <p class="fw-normal fs-md-16 fs-mb-14 mb-0">
          For full privacy policy content, please contact the PlateX team or update this page with the approved legal text.
        </p>
      </div>
    </div>
  </div>
</div>
